<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/trade/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    export default {
        name: 'real',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }
            },
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  //hasLable: true,
                  cols:[
                      { title: "用户账号", field: 'customerNumber'},
                      { click: "查询"},
                      ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.balance.balance.realQuery, //请求路径和参数
                    selection: false,
                    sequence: true,
                    cols: [
                        { title: "用户账号", field: 'customerNumber'},
                        { title: "用户总金额", field: 'balance'},
                        { title: "交易盈亏", field: 'orderProfit'},
                        { title: "更新时间", field: 'updateTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                        }},
                    ]
                }
            }
        }
    }
</script>
